module.exports = __webpack_public_path__ + "fonts/TTNormsPro-LightItalic.d0f0beb4.ttf";